import { useParams } from "react-router-dom";
export default function TournamentPage() {
  const { tournament } = useParams();
  return (
    <div className="home">
      <div className="home-column">
        <h1>coming soon</h1>
        <p>content is being migrated from the old site</p>
      </div>
    </div>
  );
}